import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dispatch, SetStateAction, useEffect, useRef, useState } from "react";
import { useForm, FormProvider } from "react-hook-form";

import {
    ListarEmpreendimentosController,
    ListarProdutosPorEmpreendimentosController,
} from "../../../../Controllers/Geral/Produtos/ProdutosControllers";
import useAsyncCallback from "../../../../hooks/useAsyncCallback";
import {
    ClienteInterface,
    IClienteFilter,
} from "../../../../Interfaces/Geral/GestaoClientes/GestaoClientesInterfaces";
import {
    IEmpreendimento,
    IUnidade,
} from "../../../../Interfaces/Geral/Produtos/ProdutosInterface";
import UnForm from "../../../../Components/Form";
import Select from "react-select";
import useAsyncEffect from "../../../../hooks/useAsyncEffect";
import { Spinner } from "../../../../Components/Loding/SpinnerPadrao";
interface IFilterClienteRow {
    setTotalPaginas: Dispatch<SetStateAction<number>>;
    setLstClientes: Dispatch<SetStateAction<ClienteInterface[] | undefined>>;
    setLoading: Dispatch<SetStateAction<boolean>>;
    lstUnidades: IUnidade[];
    setFilter: Dispatch<SetStateAction<IClienteFilter>>;
    setLstUnidades: Dispatch<SetStateAction<IUnidade[]>>;
    lstEmpreendimentos: IEmpreendimento[];
    updateClientes: (page: number, filter: IClienteFilter) => void;
    filter: IClienteFilter;
    setIdEmpreendimento: Dispatch<SetStateAction<string | number[]>>;
    idEmpreendimento: string | number[];
    loading: boolean;
}

export default function FilterClienteRow(props: IFilterClienteRow) {
    const [options, setOptions] = useState<
        Array<{ value: number; label: string }> | undefined
    >();

    const FormMethods = useForm();
    const { reset } = FormMethods;
    const filtroInicial = {
        DS_EMAIL: "",
        DS_NOME: "",
        NR_CPF: "",
        NR_TELEFONE: "",
        ID_EMPREENDIMENTO: [0],
        ID_UNIDADE: 0,
        ID_VENDA: "",
    };

    function handleFilterFormSubmit(formData: IClienteFilter) {
        props.setFilter({
            ...formData,
            DS_EMAIL: formData.DS_EMAIL,
            DS_NOME: formData.DS_NOME,
            ID_UNIDADE: formData.ID_UNIDADE,
            ID_VENDA: formData.ID_VENDA,
            NR_CPF: formData.NR_CPF,
            NR_TELEFONE: formData.NR_TELEFONE,
            FL_CHAVE_ERP: formData.FL_CHAVE_ERP,
        });
        sessionStorage.setItem(
            "FILTRO_GESTAO_CLIENTES",
            JSON.stringify({ ...formData })
        );
        props.updateClientes(1, formData);
    }
    const { execute: listarUnidades, value: unidadesListadas } =
        useAsyncCallback(ListarProdutosPorEmpreendimentosController);
    const idEmpreendimentoRef = useRef<any>();

    const limparFiltros = () => {
        idEmpreendimentoRef.current?.clearValue();
    };
    const customStyles = {
        control: (base: any) => ({
            ...base,
            boxShadow: "none",
            border: "1px solid #e4e6ef",
            transition:
                "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
        }),
    };

    const { value: listarEmpreendimentos } = useAsyncEffect(
        () => ListarEmpreendimentosController(),
        []
    );

    useEffect(() => {
        setOptions(() =>
            listarEmpreendimentos?.map((empreendimento) => ({
                label: empreendimento.DS_EMPREENDIMENTO,
                value: empreendimento.ID_EMPREENDIMENTO,
            }))
        );
    }, [listarEmpreendimentos]);

    return (
        <FormProvider {...FormMethods}>
            <UnForm
                usingContext
                handleSubmit={handleFilterFormSubmit}
                className="form-group row"
            >
                <div className="col-12 mt-3">
                    <label>Nome</label>
                    <UnForm.Input
                        className="form-control"
                        type="text"
                        name="DS_NOME"
                        defaultValue={props.filter.DS_NOME}
                    />
                </div>
                <div className="col-12 mt-3">
                    <label>E-mail</label>
                    <UnForm.Input
                        className="form-control"
                        type="email"
                        name="DS_EMAIL"
                        defaultValue={props.filter.DS_EMAIL}
                    />
                </div>
                <div className="col-12 mt-3">
                    <label>CPF/CNPJ</label>
                    <UnForm.Input
                        className="form-control"
                        type="text"
                        maxLength={14}
                        name="NR_CPF"
                        defaultValue={props.filter.NR_CPF}
                    />
                </div>
                <div className="col-12 mt-3">
                    <label>Telefone</label>
                    <UnForm.Input
                        className="form-control"
                        type="text"
                        name="NR_TELEFONE"
                        defaultValue={props.filter.NR_TELEFONE}
                    />
                </div>
                <div className="col-12 mt-3">
                    <label>Código da Venda</label>
                    <UnForm.Input
                        className="form-control"
                        type="text"
                        maxLength={14}
                        name="ID_VENDA"
                        defaultValue={props.filter.ID_VENDA}
                    />
                </div>
                <div className="col-12 mt-3">
                    <label>Empreendimento</label>
                    <Select
                        name="ID_EMPREENDIMENTO"
                        ref={idEmpreendimentoRef}
                        options={options}
                        isClearable
                        isMulti
                        onChange={(e) => {
                            props.setIdEmpreendimento(
                                e.map((value) => value?.value)
                            );
                            listarUnidades({
                                ID_EMPREENDIMENTO: e.map(
                                    (value) => value?.value
                                ),
                            });
                        }}
                        components={{
                            DropdownIndicator: () => null,
                            IndicatorSeparator: () => null,
                        }}
                        styles={customStyles}
                        placeholder={""}
                        noOptionsMessage={() => "Nenhuma opção"}
                    />
                    {/* <select
                        className="form-control"
                        name="ID_EMPREENDIMENTO"
                        ref={register()}
                        defaultValue={props.filter.ID_EMPREENDIMENTO}
                        onChange={async (event) => {
                            const ID_EMPREENDIMENTO = Number.parseInt(
                                event.target.value
                            );
                            const empreendimento = props.lstEmpreendimentos.find(
                                (empreendimento) =>
                                    empreendimento.ID_EMPREENDIMENTO ===
                                    ID_EMPREENDIMENTO
                            );
                            if (empreendimento) {
                                if (!empreendimento?.LISTA_PRODUTOS) {
                                    empreendimento.LISTA_PRODUTOS =
                                        await ListarProdutosComUnidadesController(
                                            empreendimento.ID_EMPREENDIMENTO
                                        );
                                }
                                props.setLstUnidades(
                                    empreendimento.LISTA_PRODUTOS.reduce(
                                        (unidades, produto) =>
                                            unidades.concat(produto.UNIDADES || []),
                                        [] as Array<IUnidade>
                                    )
                                );
                            } else {
                                props.setLstUnidades([]);
                            }
                        }}
                    >
                        <option value={0}></option>
                        {props.lstEmpreendimentos.map((empreendimento) => (
                            <option
                                key={empreendimento.ID_EMPREENDIMENTO}
                                value={empreendimento.ID_EMPREENDIMENTO}
                            >
                                {empreendimento.DS_EMPREENDIMENTO}
                            </option>
                        ))}
                    </select> */}
                </div>
                <div className={`col-12 mt-3 `}>
                    <label>Unidade</label>
                    <UnForm.Select
                        className="form-control"
                        name="ID_UNIDADE"
                        defaultValue={props.filter.ID_UNIDADE}
                    >
                        <option value={0}></option>
                        {unidadesListadas?.map((unidade) => (
                            <option
                                key={unidade?.ID_PRODUTO}
                                value={unidade?.ID_PRODUTO}
                            >
                                {unidade.DS_PRODUTO}
                            </option>
                        ))}
                    </UnForm.Select>
                </div>
                <div className={`col-12 mt-3 `}>
                    <label>Possui Venda</label>
                    <div className="d-flex justify-content-start">
                        <UnForm.Switch
                            color="success"
                            name="FL_CHAVE_ERP"
                            type="checkbox"
                            defaultChecked={true}
                        />
                    </div>
                </div>
                {props.loading ? (
                    <div className="col-12 d-flex align-items-end justify-content-start">
                        <button
                            type="button"
                            className="btn btn-block btn-dark mt-2"
                            style={{ cursor: "default" }}
                        >
                            <Spinner />
                        </button>
                    </div>
                ) : (
                    <UnForm.SubmitButton
                        color="success"
                        icon={faFilter}
                        type="submit"
                        className="btn btn-block btn-outline-dark mt-2"
                    >
                        Filtrar
                    </UnForm.SubmitButton>
                )}

                <div className="col-12 d-flex align-items-end justify-content-start">
                    <button
                        type="button"
                        onClick={() => {
                            window.sessionStorage.removeItem(
                                "FILTRO_GESTAO_CLIENTES"
                            );

                            reset(filtroInicial);
                            limparFiltros();
                        }}
                        className="btn btn-block btn-outline-danger mt-2"
                    >
                        <FontAwesomeIcon icon={faTimes} className="mr-2" />
                        Limpar Filtros
                    </button>
                </div>
            </UnForm>
        </FormProvider>
    );
}
